/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown>, members: NonNullable<unknown>, billed: NonNullable<unknown> }} Partner_Detail_Row_Plan_BilledInputs */



/**
* | output |
* | --- |
* | "{plan} · {members} members ({billed} billed)" |
*
* @param {Partner_Detail_Row_Plan_BilledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_row_plan_billed = /** @type {((inputs: Partner_Detail_Row_Plan_BilledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_Row_Plan_BilledInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.plan} · ${i?.members} Mitglieder (${i?.billed} abgerechnet)`)
	return /** @type {LocalizedString} */ (`${i?.plan} · ${i?.members} members (${i?.billed} billed)`)
});